import Button from 'molecules/Button';

import ProductCard from 'components/ProductListing/ProductCard';
import styles from 'components/ProductListing/product-listing.module.scss';

import { isNonEmptyArray } from 'utils/functions';

import type { ProductListingType } from 'components/ProductListing/config';
import type { FC } from 'react';

const ProductListing: FC<ProductListingType> = ({ cards, callToAction }) => (
  <div className={styles.productListing}>
    {isNonEmptyArray(cards) && (
      <div className={styles.productCardsContainer}>
        {cards.map((card, index) => (
          <ProductCard key={index} productType={card?.productType || ''} body={card?.body || ''} />
        ))}
      </div>
    )}
    {callToAction?.link && (
      <Button
        className={styles.arrowLink}
        direction="right"
        label={callToAction?.text}
        url={callToAction?.link}
        iconId="arrow-right"
      />
    )}
  </div>
);

export default ProductListing;
